import { rem } from '../../../utils/rem';
export var MuiSnackbarContent = {
    styleOverrides: {
        root: {
            paddingTop: 2,
            paddingBottom: 2,
        },
        message: { fontSize: rem(14) },
    },
};
